<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <b-tabs content-class="crypto-buy-sell-nav-content p-4" nav-class="nav-tabs-custom">
            <b-tab title="Geral" active>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Site da Nota Fiscal" label-for="par_site_nota">
                    <input
                        class="form-control"
                        v-model="parametro.par_site_nota"
                        :class="{'is-invalid': $v.parametro.par_site_nota.$error }"
                        id="par_site_nota" type="text">
                    <h6 v-show="$v.parametro.par_site_nota.$error" class="invalid-feedback">
                      Informe o site</h6>
                    <div class="text-muted">
                      Exemplo: https://nfse.municipio.uf.gov.br/
                    </div>
                  </b-form-group>
                </div>
              </div>
              <fieldset class="row border div-group">
                <legend class="div-group">Simples Nacional</legend>
                <div class="col-md-3">
                  <b-form-group label="Implantação" label-for="par_implantacao">
                    <p class="mt-3 font-weight-bold">{{ parametro.par_implantacao | formatCompetencia }}</p>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="'" class="text-white" label-for="par_apuracao_simples">
                    <b-form-checkbox v-model="parametro.par_apuracao_simples" class="text-dark mt-3 mb-2 mr-sm-3">Apurar
                      Simples Nacional
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </fieldset>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Texto de Solicitação" label-for="par_texto_solicitacao">
                    <ckeditor v-model="parametro.par_texto_solicitacao" :editor="editor"></ckeditor>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" @click="salvaGeral(parametro)" class="btn btn-label btn-success mt-3"><i
                      class="bx bx-save label-icon"></i>
                    Salvar
                  </button>
                </div>
              </div>
            </b-tab>
            <b-tab title="Tributação da Nota">
              <fieldset class="row border div-group">
                <legend class="div-group">Definição de Dias</legend>
                <div class="col-md-4 col-lg-3">
                  <b-form-group label="Dia Vencimento ISS" label-for="par_venc_iss">
                    <input class="form-control text-right"
                           v-model="tributacao.par_venc_iss"
                           maxlength="2"
                           :class="{'is-invalid': $v.tributacao.par_venc_iss.$error }"
                           id="par_venc_iss" type="text">
                    <h6 v-show="$v.tributacao.par_venc_iss.$error" class="invalid-feedback">
                      Informe dia entre 1 a 28</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4 col-lg-3">
                  <b-form-group label="Dia Vencimento ISS Retido" label-for="par_venc_retido">
                    <input class="form-control text-right"
                           v-model="tributacao.par_venc_retido"
                           maxlength="2"
                           :class="{'is-invalid': $v.tributacao.par_venc_retido.$error }"
                           id="par_venc_retido" type="text">
                    <h6 v-show="$v.tributacao.par_venc_retido.$error" class="invalid-feedback">
                      Informe dia entre 1 a 28</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4 col-lg-3">
                  <b-form-group label="Dias limite p/ Recebimento" label-for="par_limite_recebimento">
                    <b-input-group>
                      <input class="form-control text-right"
                             v-model="tributacao.par_limite_recebimento"
                             :class="{'is-invalid': $v.tributacao.par_limite_recebimento.$error }"
                             id="par_limite_recebimento" type="text">
                      <b-input-group-append>
                        <b-input-group-text>dias</b-input-group-text>
                      </b-input-group-append>
                      <h6 v-show="$v.tributacao.par_limite_recebimento.$error" class="invalid-feedback">
                        Informe a quantidade de dias</h6>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-md-4 col-lg-3">
                  <b-form-group label="Prazo p/ Bloqueio Automático" label-for="par_prazo_bloqueio">
                    <b-input-group>
                      <input class="form-control text-right"
                             v-model="tributacao.par_prazo_bloqueio"
                             id="par_prazo_bloqueio" type="text">
                      <b-input-group-append>
                        <b-input-group-text>dias</b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                    <h6 class="font-size-11 text-muted">
                      Deixe em branco para desabilitar</h6>
                  </b-form-group>
                </div>
              </fieldset>
              <fieldset class="row border div-group">
                <legend class="div-group">Taxas</legend>
                <div class="col-md-4">
                  <b-form-group label="Tributo ISS Normal" label-for="par_tributo_iss">
                    <select id="par_tributo_iss"
                            v-model="tributacao.par_tributo_iss"
                            :class="{'is-invalid': $v.tributacao.par_tributo_iss.$error }"
                            class="custom-select"
                            type="text">
                      <option v-for="t in list_tributos.filter(v => v.tip_codigo ==='40')" v-bind:value="t.trb_codigo"
                              v-bind:key="t.trb_codigo">
                        {{ t.trb_nome }}
                      </option>
                    </select>
                    <h6 v-show="$v.tributacao.par_tributo_iss.$error" class="invalid-feedback">
                      Informe o tributo</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Tributo ISS Retido" label-for="par_tributo_issretido">
                    <select id="par_tributo_issretido"
                            v-model="tributacao.par_tributo_issretido"
                            :class="{'is-invalid': $v.tributacao.par_tributo_issretido.$error }"
                            class="custom-select"
                            type="text">
                      <option v-for="t in list_tributos.filter(v => v.tip_codigo ==='40')" v-bind:value="t.trb_codigo"
                              v-bind:key="t.trb_codigo">
                        {{ t.trb_nome }}
                      </option>
                    </select>
                    <h6 v-show="$v.tributacao.par_tributo_issretido.$error" class="invalid-feedback">
                      Informe o tributo</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Tributo IRRF Retido" label-for="par_tributo_irrf">
                    <select id="par_tributo_irrf"
                            v-model="tributacao.par_tributo_irrf"
                            :class="{'is-invalid': $v.tributacao.par_tributo_irrf.$error }"
                            class="custom-select"
                            type="text">
                      <option v-for="t in list_tributos.filter(v => v.tip_codigo ==='89')" v-bind:value="t.trb_codigo"
                              v-bind:key="t.trb_codigo">
                        {{ t.trb_nome }}
                      </option>
                    </select>
                    <h6 v-show="$v.tributacao.par_tributo_irrf.$error" class="invalid-feedback">
                      Informe o tributo</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Tributo Taxa de Emissão NFA-e" label-for="par_tributo_txnfavulsa ">
                    <select id="par_tributo_txnfavulsa"
                            v-model="tributacao.par_tributo_txnfavulsa"
                            :class="{'is-invalid': $v.tributacao.par_tributo_txnfavulsa.$error }"
                            class="custom-select"
                            type="text">
                      <option v-for="t in list_tributos.filter(v => v.tip_codigo ==='89')" v-bind:value="t.trb_codigo"
                              v-bind:key="t.trb_codigo">
                        {{ t.trb_nome }}
                      </option>
                    </select>
                    <h6 v-show="$v.tributacao.par_tributo_txnfavulsa.$error" class="invalid-feedback">
                      Informe o tributo</h6>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Taxa de Emissão NFA-e" label-for="par_valor_txnfavulsa">
                    <money class="form-control" id="par_valor_txnfavulsa"
                           v-model="tributacao.par_valor_txnfavulsa"
                           v-bind="money"></money>
                  </b-form-group>
                </div>
              </fieldset>
              <fieldset class="row border div-group">
                <legend class="div-group">Permissões para Cancelamento e Substituição de Notas</legend>
                <div class="col-md-3">
                  <b-form-group label="Prazo para Substituição " label-for="par_prazo_subistituir">
                    <b-input-group>
                      <input class="form-control text-right"
                             v-model="tributacao.par_prazo_subistituir"
                             :class="{'is-invalid': $v.tributacao.par_prazo_subistituir.$error }"
                             id="par_prazo_subistituir" type="text">
                      <b-input-group-append>
                        <b-input-group-text>dias</b-input-group-text>
                        <b-button v-show="false" variant="outline-info"
                                  v-b-popover.hover.top="'I am popover directive content!'"
                                  title="Prazo para Substituição">
                          <i class="fas fa-info-circle"></i>
                        </b-button>
                      </b-input-group-append>
                      <h6 v-show="$v.tributacao.par_prazo_subistituir.$error" class="invalid-feedback">
                        Informe a quantidade de dias</h6>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Prazo para Autocancelamento" label-for="par_prazo_autocancelar">
                    <b-input-group>
                      <input class="form-control text-right"
                             v-model="tributacao.par_prazo_autocancelar "
                             id="par_prazo_autocancelar" type="text">
                      <b-input-group-append>
                        <b-input-group-text>dias</b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="'" class="text-white" label-for="par_permite_troca_competencia">
                    <b-form-checkbox v-model="tributacao.par_permite_troca_competencia"
                                     class="text-dark mt-3 mb-2 mr-sm-3">Permite a Troca de Competência
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </fieldset>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label-for="par_valor_txnfavulsa">
                    <button type="button" @click="salvaTributo(tributacao)" class="btn btn-label btn-success"><i
                        class="bx bx-save label-icon"></i>
                      Salvar
                    </button>
                  </b-form-group>
                </div>
              </div>
            </b-tab>
            <b-tab title="Arrecadação">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Tipo de Cobrança" label-for="par_tipo_cobranca">
                    <select id="par_tipo_cobranca"
                            v-model="arrecadacao.par_tipo_cobranca"
                            :class="{'is-invalid': $v.arrecadacao.par_tipo_cobranca.$error }"
                            class="custom-select"
                            type="text">
                      <option value="1">Arrecadação com API</option>
                      <option value="3">Arrecadação</option>
                      <option value="2">Boleto Bancário</option>
                      <option value="99">Sem Convênio On-line</option>
                    </select>
                    <h6 v-show="$v.arrecadacao.par_tipo_cobranca.$error" class="invalid-feedback">
                      Informe qual tipo de cobrança</h6>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <b-form-group label="Banco" label-for="ban_codigo">
                    <select id="ban_codigo"
                            v-model="arrecadacao.ban_codigo"
                            :class="{'is-invalid': $v.arrecadacao.ban_codigo.$error }"
                            class="custom-select"
                            type="text">
                      <option value="1">Banco do Brasil S.A.</option>
                      <option value="104">Caixa Econômica Federal</option>
                      <option value="237">Bradesco S.A.</option>
                      <option value="748">Banco Cooperativo Sicredi S.A.</option>
                    </select>
                    <h6 v-show="$v.arrecadacao.ban_codigo.$error" class="invalid-feedback">
                      Informe qual Banco</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Convênio/Cedente" label-for="par_convenio">
                    <input id="par_convenio"
                           v-model="arrecadacao.par_convenio"
                           :class="{'is-invalid': $v.arrecadacao.par_convenio.$error }"
                           class="form-control"
                           type="text">
                    <h6 v-show="$v.arrecadacao.par_convenio.$error" class="invalid-feedback">
                      Informe número do convênio</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Agência (Sem dígito)" label-for="par_agencia">
                    <input id="par_agencia"
                           v-model="arrecadacao.par_agencia"
                           :class="{'is-invalid': $v.arrecadacao.par_agencia.$error }"
                           class="form-control"
                           type="text">
                    <h6 v-show="$v.arrecadacao.par_agencia.$error" class="invalid-feedback">
                      Informe número da agência sem o dígito</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Conta (Sem dígito)" label-for="par_conta">
                    <input id="par_conta"
                           v-model="arrecadacao.par_conta"
                           :class="{'is-invalid': $v.arrecadacao.par_conta.$error }"
                           class="form-control"
                           type="text">
                    <h6 v-show="$v.arrecadacao.par_conta.$error" class="invalid-feedback">
                      Informe número da conta sem o dígito</h6>
                  </b-form-group>
                </div>
              </div>
              <div v-if="arrecadacao.par_tipo_cobranca === '1' || arrecadacao.par_tipo_cobranca === '3'" class="row">
                <div class="col-md-4">
                  <b-form-group label="Tipo de Moeda" label-for="par_feb_moeda">
                    <select id="par_feb_moeda"
                            @change="selTipoMoeda()"
                            v-model="arrecadacao.par_feb_moeda"
                            class="custom-select"
                            type="text">
                      <option value="6">Moeda Fixa</option>
                      <option value="7">Moeda Váriavel</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Código Febraban" label-for="par_feb_codigo">
                    <input class="form-control"
                           maxlength="4"
                           v-model="arrecadacao.par_feb_codigo"
                           id="par_feb_codigo " type="text">
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Exibir Valor no Código de Barra" label-for="par_feb_mostra_valor ">
                    <div
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3 mt-3 custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input"
                             v-bind:disabled="arrecadacao.par_feb_moeda === '6'"
                             v-model="arrecadacao.par_feb_mostra_valor"
                             id="par_feb_mostra_valor">
                      <label class="custom-control-label" for="par_feb_mostra_valor">Sim</label>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div v-if="arrecadacao.par_tipo_cobranca === '2'" class="row">
                <div class="col-md-2">
                  <b-form-group label="Carteira/Posto" label-for="par_carteira">
                    <input id="par_carteira"
                           v-model="arrecadacao.par_carteira"
                           :class="{'is-invalid': $v.arrecadacao.par_carteira.$error }"
                           class="form-control"
                           type="text">
                    <h6 v-show="$v.arrecadacao.par_carteira.$error" class="invalid-feedback">
                      Informe número carteira</h6>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-form-group label="Variação" label-for="par_variacao">
                    <input id="par_variacao"
                           v-model="arrecadacao.par_variacao"
                           :class="{'is-invalid': $v.arrecadacao.par_variacao.$error }"
                           class="form-control"
                           type="text">
                    <h6 v-show="$v.arrecadacao.par_variacao.$error" class="invalid-feedback">
                      Informe o número da variação</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Local de Pagamento" label-for="par_instrucao_caixa">
                        <textarea
                            v-model="arrecadacao.par_local_pagamento"
                            :class="{'is-invalid': $v.arrecadacao.par_local_pagamento.$error }"
                            class="form-control"
                            :maxlength="150"
                            rows="2"
                            placeholder="Informe o local de pagamento (máximo de 150 caracteres)">
                        </textarea>
                    <h6 v-show="$v.arrecadacao.par_local_pagamento.$error" class="invalid-feedback">
                      Informe o local de pagamento</h6>
                    <div class="text-center">
                      <p v-if="arrecadacao.par_local_pagamento" class="badge position-absolute"
                         :class="{ 'badge-success': arrecadacao.par_local_pagamento.length !== 150,
                            'badge-danger': arrecadacao.par_local_pagamento.length === 150 }">
                        {{ arrecadacao.par_local_pagamento.length }} / 150
                      </p>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Instruções ao Caixa" label-for="par_instrucao_caixa">
                    <ckeditor v-model="arrecadacao.par_instrucao_caixa" :editor="editor"></ckeditor>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" @click="salvaArrecadacao(arrecadacao)" class="btn btn-label btn-success mt-3">
                    <i class="bx bx-save label-icon"></i>
                    Salvar
                  </button>
                </div>
              </div>
            </b-tab>
            <b-tab title="API Pix"
                   :disabled="(arrecadacao.par_tipo_cobranca ==='3' || arrecadacao.par_tipo_cobranca ==='99')">
              <div class="row">
                <div class="col-md-12">
                  <fieldset class="row border div-group">
                    <legend class="div-group">Informe o dados da API Pix Banco do Brasil</legend>
                    <div class="col-md-5">
                      <b-form-group label="Chave Pix" label-for="chave_pix">
                        <input class="form-control"
                               :class="{'is-invalid': $v.api_pix.par_chave_pix.$error }"
                               v-model="api_pix.par_chave_pix"
                               id="chave_pix " type="text">
                        <div v-if="$v.api_pix.par_chave_pix.$error" class="invalid-feedback">
                          Informe a chave Pix cadastrada no Banco do Brasil
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-7">
                      <b-form-group label="App Key" label-for="par_app_key_pix">
                        <input class="form-control"
                               :class="{'is-invalid': $v.api_pix.par_app_key_pix.$error }"
                               v-model="api_pix.par_app_key_pix"
                               id="par_app_key_pix" type="text">
                        <div v-if="$v.api_pix.par_app_key_pix.$error" class="invalid-feedback">
                          Informe o APP Key disponibilizado pelo Banco do Brasil
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-12">
                      <b-form-group label="App Authorization" label-for="par_app_authorization_pix">
                      <textarea
                          v-model="api_pix.par_app_authorization_pix"
                          id="par_app_authorization_pix"
                          class="form-control"
                          :class="{'is-invalid': $v.api_pix.par_app_authorization_pix.$error }"
                          rows="3"
                          placeholder="">
                        </textarea>
                        <div v-if="$v.api_pix.par_app_key_pix.$error" class="invalid-feedback">
                          Informe o APP Authorization disponibilizado pelo Banco do Brasil
                        </div>
                      </b-form-group>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" @click="salvaAPIPix(api_pix)" class="btn btn-label btn-success mt-3">
                    <i
                        class="bx bx-save label-icon"></i>
                    Salvar
                  </button>
                </div>
              </div>
            </b-tab>
            <b-tab title="API Boleto" :disabled="(arrecadacao.par_tipo_cobranca!=='2')">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group label="App Key" label-for="par_app_key">
                    <input class="form-control"
                           :class="{'is-invalid': $v.api.par_app_key.$error }"
                           v-model="api.par_app_key"
                           id="par_app_key" type="text">
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="App Authorization" label-for="par_app_authorization">
                      <textarea
                          v-model="api.par_app_authorization"
                          class="form-control"
                          :class="{'is-invalid': $v.api.par_app_authorization.$error }"
                          rows="3"
                          placeholder="">
                        </textarea>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" @click="salvaAPI(api)" class="btn btn-label btn-success mt-3">
                    <i
                        class="bx bx-save label-icon"></i>
                    Salvar
                  </button>
                </div>
              </div>
            </b-tab>
            <b-tab title="Certificado">
              <div class="row">
                <div class="col-md-12">
                  <fieldset v-if="certificado.cet_vencimento" class="row border div-group">
                    <legend class="div-group">Dados do Certificado Digital</legend>
                    <div class="col-md-8">
                      <b-form-group label="Emitido Para" label-for="cet_emitido_para">
                        <p class="mt-3 font-weight-bold">{{ certificado.cet_emitido_para }}</p>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group label="Vencimento" label-for="cet_vencimento">
                        <p class="mt-3 font-weight-bold">{{ certificado.cet_vencimento | formatDate }}</p>
                      </b-form-group>
                    </div>
                  </fieldset>
                  <fieldset class="row border div-group">
                    <legend class="div-group">Arquivo PFX</legend>
                    <div class="col-md-12">
                      <b-form-group label="Selecione um arquivo pfx para incluir ou atualizar o certificado"
                                    label-for="cet_pem">
                        <vue-dropzone id="dropzone"
                                      ref="myVueDropzone"
                                      v-on:vdropzone-processing="sendFileProcessing"
                                      v-on:vdropzone-success="sendFileComplete"
                                      v-on:vdropzone-file-added="onFileAdded"
                                      v-on:vdropzone-sending="onSending"
                                      :options="dropzoneOptions"></vue-dropzone>
                        <div class="text-muted">
                          Somente arquivo pfx com tamanho máximo de 2MB.
                        </div>
                      </b-form-group>
                    </div>
                  </fieldset>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <b-modal
          id="modal-envia-certificado"
          ref="modal-envia-certificado"
          size="md"
          title="Senha do Certificado"
          title-class="font-18"
          :hide-header-close="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true">
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <b-form-group label="Informe a senha" label-for="cert_senha">
                <input id="cert_senha" v-model="cert_senha" autocomplete="new-password"
                       autocorrect="off"
                       autocapitalize="off"
                       spellcheck="false" type="password" class="form-control">
              </b-form-group>
            </div>
            <div class="col-12">
              <p>A senha do certificado digital será utilizada somente durante o processamento da operação, não sendo
                armazenada em banco de dados, arquivos de log ou qualquer outro meio persistente.</p>
            </div>
          </div>
        </div>
        <template #modal-footer="{ ok, cancel}">
          <button v-if="httpSendFile" type="button" disabled class="btn btn-label btn-sm mr-2 mb-2 btn-primary"><i
              class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i> Processando
          </button>
          <button v-else type="button" title="Enviar Certificado"
                  @click="sendFileProcessing()"
                  class="btn btn-label btn-sm mr-2 mb-2 btn-primary"><i
              class="bx bx-save label-icon"></i> Salvar Certificado
          </button>
          <button type="button" title="Cancelar"
                  v-bind:disabled="httpSendFile"
                  @click="closeModal('modal-envia-certificado')"
                  class="btn btn-label btn-sm mr-2 mb-2 btn-outline-danger"><i
              class="bx bx-block label-icon"></i> Cancelar
          </button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import {maxValue, minValue, required} from "vuelidate/lib/validators";
import {VMoney, Money} from 'v-money'
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vue2Dropzone from 'vue2-dropzone';
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde";
import {GetParamentroGeral, setParamentroGeral} from "@/api/admin/configuracao/paramentro";
import {getTributos} from "@/api/geral/helps";
import {tipoBoolean} from "@/helps/util";
import {notifyErro, notifySucesso} from "@/helps/notificacao";
import {uploadCertificao} from "@/api/core/upload";
import {getEntidade} from "@/api/config/init";
import {getToken} from "@/api/config/token";

export default {
  page: {
    title: "Configurações",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Money,
    Aguarde,
    ckeditor: CKEditor.component,
    vueDropzone: vue2Dropzone
  },
  directives: {money: VMoney},
  data() {
    return {
      title: "Configurações",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Configurações',
          active: true,
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      editor: ClassicEditor,
      dropzoneOptions: {
        dictFileTooBig: "O arquivo é muito grande ({{filesize}}MB). Tamanho máximo permitido: {{maxFilesize}}MB",
        dictRemoveFile: "Clique aqui para remover",
        dictCancelUpload: "Cancelar envio",
        dictCancelUploadConfirmation: "Tem certeza de que deseja cancelar o envio ?",
        dictMaxFilesExceeded: "Você não pode enviar mais arquivos",
        url: uploadCertificao(),
        paramName: "arquivo",
        createImageThumbnails: false,
        acceptedFiles: ".pfx",
        disablePreviews: true,
        maxFilesize: 2,
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='mdi mdi-upload'></i> Solte o arquivo, ou clique aqui para selecionar",
        headers: {"X-ACCESS-ENTIDADE": getEntidade(), "X-ACCESS-TOKEN": getToken()}
      },
      httpSend: false,
      httpSendFile: false,
      list_tributos: [],
      parametro: {
        par_codigo: null,
        ent_codigo: null,
        par_texto_solicitacao: '',
        par_site_nota: null,
        par_logo: null,
        par_implantacao: 0,
        par_apuracao_simples: true
      },
      tributacao: {
        par_codigo: null,
        par_venc_iss: null,
        par_venc_retido: null,
        par_tributo_iss: null,
        par_tributo_issretido: null,
        par_tributo_irrf: null,
        par_tributo_txnfavulsa: null,
        par_valor_txnfavulsa: 0.00,
        par_limite_recebimento: 60,
        par_prazo_subistituir: 180,
        par_prazo_autocancelar: 0,
        par_permite_troca_competencia: false,
        par_prazo_bloqueio: null,
      },
      arrecadacao: {
        par_codigo: null,
        par_tipo_cobranca: null,
        par_feb_moeda: null,
        par_feb_codigo: null,
        par_feb_mostra_valor: false,
        ban_codigo: null,
        par_convenio: null,
        par_carteira: null,
        par_variacao: null,
        par_agencia: null,
        par_conta: null,
        par_local_pagamento: '',
        par_instrucao_caixa: ''
      },
      api: {
        par_codigo: null,
        par_app_key: null,
        par_app_authorization: null
      },
      api_pix: {
        par_codigo: null,
        par_chave_pix: null,
        par_app_key_pix: null,
        par_app_authorization_pix: null
      },
      certificado: {
        cet_codigo: null,
        cet_vencimento: null,
        cet_emitido_para: null,
      },
      cert_senha: '',
    };
  },
  validations: {
    parametro: {
      par_site_nota: {
        required,
      }
    },
    tributacao: {
      par_venc_iss: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(28)
      },
      par_venc_retido: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(28)
      },
      par_tributo_iss: {
        required,
      },
      par_tributo_issretido: {
        required,
      },
      par_tributo_irrf: {
        required,
      },
      par_tributo_txnfavulsa: {
        required,
      },
      par_limite_recebimento: {
        required,
        minValue: minValue(1)
      },
      par_prazo_subistituir: {
        required,
        minValue: minValue(1)
      }
    },
    arrecadacao: {
      ban_codigo: {
        required
      },
      par_tipo_cobranca: {
        required,
      },
      par_local_pagamento: {
        required,
      },
      par_variacao: {
        required,
      },
      par_carteira: {
        required,
      },
      par_convenio: {
        required,
      },
      par_agencia: {
        required,
      },
      par_conta: {
        required,
      }
    },
    api: {
      par_app_key: {
        required,
      },
      par_app_authorization: {
        required,
      }
    },
    api_pix: {
      par_chave_pix: {
        required,
      },
      par_app_key_pix: {
        required,
      },
      par_app_authorization_pix: {
        required,
      }
    },
  },
  created() {
    this.listTributos()
    this.getEntidade();
  },
  methods: {
    getEntidade() {
      this.httpSend = true;
      GetParamentroGeral().then(response => {
        if (response.status) {
          const dados = response.dados.parametros;
          this.parametro = {...dados}
          this.parametro.par_apuracao_simples = tipoBoolean(this.parametro.par_apuracao_simples)
          this.tributacao = {...dados}
          this.tributacao.par_permite_troca_competencia = tipoBoolean(this.tributacao.par_permite_troca_competencia)
          this.arrecadacao = {...dados}
          if (dados.par_feb_mostra_valor) {
            this.arrecadacao.par_feb_mostra_valor = (dados.par_feb_mostra_valor === 'S');
          }
          if (response.dados.certificado) {
            this.certificado = response.dados.certificado
          }
          this.manipulaDados(dados);
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    listTributos() {
      getTributos().then(response => {
        if (response.status) {
          this.list_tributos = response.dados;
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      })
    },
    selTipoMoeda() {
      if (this.arrecadacao.par_feb_moeda === '6') {
        this.arrecadacao.par_feb_mostra_valor = true;
      }
    },
    salvaGeral(dados) {
      this.$v.parametro.$touch();
      if (this.$v.parametro.$invalid) {
        return false;
      }
      this.salvar(dados);
    },
    salvaTributo(dados) {
      this.$v.tributacao.$touch();
      if (this.$v.tributacao.$invalid) {
        return false;
      }
      this.salvar(dados);
    },
    salvaArrecadacao(dados) {
      if (dados.par_tipo_cobranca === '2') {
        this.$v.arrecadacao.$touch();
        if (this.$v.arrecadacao.$invalid) {
          return false;
        }
      }
      this.salvar(dados);
    },
    salvaAPI(dados) {
      this.$v.api.$touch();
      if (this.$v.api.$invalid) {
        return false;
      }
      this.salvar(dados);
    },
    salvaAPIPix(dados) {
      this.$v.api_pix.$touch();
      if (this.$v.api_pix.$invalid) {
        return false;
      }
      this.salvar(dados);
    },
    salvar(dados) {
      this.httpSend = true;
      setParamentroGeral(dados).then(response => {
        if (response.status) {
          notifySucesso("Sucesso", response.mensagem)
        } else {
          notifyErro("Atenção", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    manipulaDados(dados) {
      this.api.par_codigo = dados.par_codigo;
      this.api.par_app_key = dados.par_app_key;
      this.api.par_app_authorization = dados.par_app_authorization;

      this.api_pix.par_codigo = dados.par_codigo;
      this.api_pix.par_chave_pix = dados.par_chave_pix;
      this.api_pix.par_app_key_pix = dados.par_app_key_pix;
      this.api_pix.par_app_authorization_pix = dados.par_app_authorization_pix;
    },
    closeModal(ref) {
      this.$refs.myVueDropzone.removeAllFiles();
      this.$refs[ref].hide();
    },
    openModal(ref) {
      this.$refs[ref].show();
    },
    onFileAdded() {
      this.openModal('modal-envia-certificado');
    },
    sendFileProcessing() {
      this.httpSendFile = true;
      this.$refs.myVueDropzone.processQueue();
    },
    onSending(file, xhr, formData) {
      formData.append("cer_senha", this.cert_senha);
    },
    sendFileComplete(file, response) {
      if (response.status) {
        this.certificado = response.dados
        this.$refs.myVueDropzone.removeAllFiles()
        this.closeModal('modal-envia-certificado');
        notifySucesso("Sucesso", response.mensagem)
      } else {
        const msg = response.mensagem;
        if (typeof msg === 'object') {
          notifyErro("Erro no Certificado", JSON.stringify(msg))
        } else {
          notifyErro("Erro no Certificado", msg)
        }
        this.closeModal('modal-envia-certificado');
      }
      this.httpSendFile = false;
    },
  }
};
</script>
